module.exports = __webpack_public_path__ + "static/media/lamina25act1.049ea46b.png";